qw-basket-room-counter {
  display: block;
}
